export default __webpack_public_path__ + "static/media/gmail.b5c8c5ed.svg";